// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__2Jpmd","rootSuccess":"CompleteLink_rootSuccess__125Sw","rootFailure":"CompleteLink_rootFailure__2RA5-","isDisabled":"CompleteLink_isDisabled__sisIO"};